import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Lock, Mail } from 'lucide-react';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Bienvenido a SELECTO CRM');
    } catch (err) {
      toast.error('Credenciales invalidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen bg-[#03110D]" data-testid="login-page">
      <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
        <img src="https://customer-assets.emergentagent.com/job_deal-manager-pro-1/artifacts/432rn78i_IMG_6415.jpeg"
          alt="Luxury Interior" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#03110D]/80 to-transparent" />
        <div className="absolute bottom-12 left-12 text-white">
          <h2 className="font-outfit text-4xl font-bold tracking-tight">SELECTO</h2>
          <p className="text-lg mt-2 text-white/60">Gestion inmobiliaria de alto nivel</p>
        </div>
      </div>
      <div className="w-full lg:w-1/2 flex items-center justify-center bg-[#03110D] p-6 lg:p-8">
        <div className="w-full max-w-sm">
          <div className="mb-10 text-center lg:text-left">
            <h1 className="font-outfit text-4xl font-bold text-white tracking-tight">SELECTO</h1>
            <p className="text-[#A38560] mt-1 text-sm tracking-[0.2em] uppercase font-medium">CRM Inmobiliario</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label className="text-white/50 text-xs uppercase tracking-wider mb-1.5 block">Correo electronico</Label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A38560]" strokeWidth={1.5} />
                <Input data-testid="login-email" type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="tu@correo.com" className="pl-10 bg-[#0A1F1A] border-[#1A3B32] text-white placeholder:text-white/30 focus:border-[#A38560] focus:ring-1 focus:ring-[#A38560] h-12 rounded-xl" />
              </div>
            </div>
            <div>
              <Label className="text-white/50 text-xs uppercase tracking-wider mb-1.5 block">Contrasena</Label>
              <div className="relative">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A38560]" strokeWidth={1.5} />
                <Input data-testid="login-password" type="password" value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="Tu contrasena" className="pl-10 bg-[#0A1F1A] border-[#1A3B32] text-white placeholder:text-white/30 focus:border-[#A38560] focus:ring-1 focus:ring-[#A38560] h-12 rounded-xl" />
              </div>
            </div>
            <button type="submit" data-testid="login-submit-btn" disabled={loading}
              className="w-full h-12 bg-gradient-to-r from-[#A38560] to-[#8B6F47] hover:from-[#8B6F47] hover:to-[#725A3A] text-[#03110D] font-semibold rounded-xl shadow-lg shadow-[#A38560]/20 transition-all active:scale-[0.98] disabled:opacity-50">
              {loading ? 'Ingresando...' : 'Iniciar Sesion'}
            </button>
          </form>
          <p className="text-xs text-white/30 mt-8 text-center">SELECTO CRM v1.0</p>
        </div>
      </div>
    </div>
  );
}
